var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModern1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 10,
    fill: "url(#paint0_linear_4891_903)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 28L15.7322 22.2677C16.7085 21.2915 18.2915 21.2915 19.2677 22.2677L23.2323 26.2323C24.2085 27.2085 25.7915 27.2085 26.7677 26.2323L35 18M35 18V24.25M35 18H28.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4891_903",
    x1: 22.5,
    y1: 0,
    x2: 22.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02FF75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModern1);
export default __webpack_public_path__ + "static/media/modern1.99696b2aea873b145190b44a39d13914.svg";
export { ForwardRef as ReactComponent };